export function LogGrepBar({
  grep,
  onGrepChange,
}: {
  grep: string;
  onGrepChange: (value: string) => void;
}) {
  return (
    <div className="border-b border-border-subtle px-4 py-2">
      <label className="flex items-center gap-2">
        <span
          className="shrink-0 font-mono text-text-secondary"
          style={{ fontSize: "var(--font-micro)" }}
        >
          grep
        </span>
        <input
          type="search"
          value={grep}
          onChange={(e) => onGrepChange(e.target.value)}
          placeholder="Filter lines…  e.g. [close] -uptime_monitor"
          className="min-w-0 flex-1 rounded-md border border-border-subtle bg-page px-2.5 py-1.5 font-mono text-text-primary outline-none focus:border-accent"
          style={{ fontSize: "var(--font-body)" }}
          spellCheck={false}
        />
      </label>
    </div>
  );
}
